import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EatingStatus = _resolveComponent("EatingStatus")!
  const _component_VueLoading = _resolveComponent("VueLoading")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.fetchLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (child, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "pa-2",
              key: index
            }, [
              _createVNode(_component_EatingStatus, {
                child: child,
                classMealReport: _ctx.classMealReport,
                fullBtnLoading: _ctx.fullBtnLoading,
                btnLoading: _ctx.btnLoading,
                onFullEat: _ctx.fullEat,
                onCreateMealReport: _ctx.createMealReport,
                onChangeStatusItem: _ctx.changeStatusItem,
                onSendMessage: _ctx.changeStatusItem
              }, null, 8, ["child", "classMealReport", "fullBtnLoading", "btnLoading", "onFullEat", "onCreateMealReport", "onChangeStatusItem", "onSendMessage"])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_VueLoading, { height: '50vh' })
        ]))
  ]))
}